import { createQueryKeys } from '@lukemorales/query-key-factory';
import { uniqBy } from 'lodash-es';
import { getTalkInfoListWithPhone } from 'services/api/conversation.convList';
import { getTrailReportList } from 'services/api/dashboard';
import {
  getStatsAgentReviewRank,
  getStatsAgentSubmitRank,
  getStatsAiReplyConversion,
  getStatsGlobalSummary,
  getStatsQueryAgent,
  getStatsWeeklyTrend,
  StatsAgentRankBody,
  StatsQueryAgentBody,
} from 'services/api/dashboard/supplementalKnowledge';

export const dashboards = createQueryKeys('dashboards', {
  trailReportList: {
    queryKey: null,
    queryFn: ({ signal }) => getTrailReportList(signal),
  },
  supplementalKnowledgeStatsGlobalSummary: {
    queryKey: null,
    queryFn: ({ signal }) => getStatsGlobalSummary(signal),
  },
  supplementalKnowledgeStatsWeeklyTrend: {
    queryKey: null,
    queryFn: ({ signal }) => getStatsWeeklyTrend(signal),
  },
  supplementalKnowledgeStatsQueryAgent: (params: StatsQueryAgentBody) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getStatsQueryAgent(params, signal),
  }),
  supplementalKnowledgeStatsAgentSubmitRankInfinite: (
    params: Omit<StatsAgentRankBody, 'pageNo'>,
  ) => ({
    queryKey: [params],
    queryFn: ({ pageParam, signal }) =>
      getStatsAgentSubmitRank({ ...params, pageNo: (pageParam as number) ?? 1 }, signal),
  }),
  supplementalKnowledgeStatsAgentSubmitRank: (params: StatsAgentRankBody) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getStatsAgentSubmitRank(params, signal),
  }),
  supplementalKnowledgeStatsAgentReviewRank: (params: Omit<StatsAgentRankBody, 'pageNo'>) => ({
    queryKey: [params],
    queryFn: ({ pageParam, signal }) =>
      getStatsAgentReviewRank({ ...params, pageNo: (pageParam as number) ?? 1 }, signal),
  }),
  supplementalKnowledgeStatsAiReplyConversionInfinite: (
    params: Omit<StatsAgentRankBody, 'pageNo'>,
  ) => ({
    queryKey: [params],
    queryFn: async ({ pageParam, signal }) => {
      const res = await getStatsAiReplyConversion(
        { ...params, pageNo: (pageParam as number) ?? 1 },
        signal,
      );
      const talkInfoList = await getTalkInfoListWithPhone(
        res.conversations.map((conversation) => conversation.conversationId),
        signal,
      );

      return {
        total: res.total,
        conversations: res.conversations,
        talkInfoList: uniqBy(
          talkInfoList?.aggTalks.map(({ talk }) => talk) ?? [],
          'conversationId',
        ),
      };
    },
  }),
});
